//
// DISCLAIMER
//
// Copyright 2026 ArangoDB GmbH, Cologne, Germany
//

import { useMemo } from "react";
import { useDeploymentStore } from "../../util/storage/DeploymentStore";
import { useArangoPlatformFeature } from "./useArangoPlatformFeature";

const isBundleBasedPlatformEnabled = (bundleId?: string) => {
  if (!bundleId || bundleId === "coredb") {
    return false;
  }
  return true;
};

export const useArangoPlatform = (organizationId?: string, regionId?: string) => {
  const { deployment } = useDeploymentStore();
  const { isArangoPlatformFeature } = useArangoPlatformFeature(organizationId);

  const isArangoDBPlatformEnabled = useMemo(() => {
    if (!isArangoPlatformFeature) {
      return !!deployment.arangodb_platform_enabled || isBundleBasedPlatformEnabled(deployment.arangodb_platform_bundle);
    }
    return isBundleBasedPlatformEnabled(deployment.arangodb_platform_bundle);
  }, [deployment.arangodb_platform_bundle, deployment.arangodb_platform_enabled, isArangoPlatformFeature]);

  return { isArangoDBPlatformEnabled };
};
